 
const TRANSLATION = {
    FRENCH: {
        DESCRIPTION: "Description détaillée",
        FREE_IN_N_HOURS_FROM: (days = 2, price = 300, symbol, precision) => `DÉLAI DE LIVRAISON ${days}j`,/*H À PARTIR DE ${MaskOnBlur(price,symbol,precision)} */
        ADD_TO_CART: 'Ajouter au panier',
        CART: "Panier",
        REFERENCE: (ref) => `Référence : ${ref}`,
        SIGN_IN: 'Connexion',
        ALREADY_HAVE_AN_ACCOUNT: 'Vous avez déjà un compte ? ',
        ALREADY_EXIST_EMAIL: 'Cet email est déjà associé à un compte existant.',
        CLICK_ON:'Veuillez cliquer sur ',
        FOR_CONNEXION:'pour vous connecter.',
        PASSWORD_FORGOTTEN:'Si vous avez oublié votre mot de passe, utilisez l’option',
        PASSWORD_RESET:'pour le réinitialiser.',
        CREATE: 'Créer',
        PASSWORD: 'Mot de passe',
        EMAIL: 'Email',
        LAST_NAME: 'Nom',
        FIRST_NAME: 'Prénom',
        FIELD_REQUIRED: "Ce champ est obligatoire",
        INVALID_EMAIL_ADDRESS: "Adresse e-mail non valide",
        INVALID_PHONE_NUMBER: "Numéro de téléphone invalide",
        CUSTOMER_LOGIN: 'Connectez-vous',
        NEW_CUSTOMER_SIGN_UP: "Nouveau client? S'enregistrer!",
        ACCOUNT: 'Compte',
        CREATE_ACCOUNT: 'Créer un compte',
        LANGUAGE: 'Langue',
        ENGLISH: 'Anglais',
        FRENCH: 'Français',
        FORGOT_PASSWORD: "Mot de passe oublié ?",
        TITLE_FORGOT_PASSWORD: "Mot de passe oublié", 
        ENTER_CODE: "Saisir le code",
        CONFIRMATION: "Confirmation",
        CHANGE: "Changer",
        PASSWORD_MUST_BE_AT_LEAST_6_CHARACTERS: "Mot de passe doit être au moins de 6 caractères",
        PASSWORDS_ARE_NOT_THE_SAME: "Les mots de passe ne sont pas identiques",
        PLEASE_CONFIRM_YOUR_NEW_PASSWORD: 'Veuillez confirmer votre nouveau mot de passe',
        PASSWORD_REQUIREMENTS: "Votre mot de passe doit contenir au moins : 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial",
        NEW_PASSWORD: "Nouveau mot de passe",
        IS_COMPANY: 'Société',
        "IS_COMPANY_?": 'Client société ?',
        COMPANY_NAME: "Raison sociale",
        MY_CART: "Mon panier",
        MY_CART_UIX2:(nb)=>`Mon panier (${nb} article${nb !== 1 ? 's' : ''})`,
POSTAL_INVOICING_ADRESS:"",
        CELLPHONE: "Téléphone",
        CREATE_AN_ACCOUNT: "Créer un compte",
        OPERATION_CHANGE_PASSWORD_SUCCESS: 'Votre mot de passe a été modifié avec succès !',
        OPERATION_SUCCESS: "Opération effectuée avec succès",
        PRODUCTS_LEFT: (stoke = 0, withNegativeStock = false, articleId) => withNegativeStock && articleId ? 'En stock' : (stoke > 0 && articleId) ? `Il reste ${stoke} produits` : 'Epuisé',
        PRODUCTS_LEFT_SHOPY: (stoke = 0, withNegativeStock = false, articleId) => (withNegativeStock ||stoke > 0) && articleId ? '✓ En stock' :'✗ Non disponible',
        SHOP_NOW: "Acheter",
        SEARCH: "Chercher",
        PRODUCT: 'Produit',
        TOTAL: 'Total',
        QTY: 'Qté',
        REMOVE: 'Supprimer',
        CHECK_OUT: "Passer à la caisse",
        VALIDATE_CART: "Retrait en magasin",
        PROCEED_TO_PAYMENT: "Paiement en ligne",
        ARTICLE_NOT_FOUND: "Article non trouvé",
        ARTICLE_NOT_ACTIF: "Article non actif",
        ARTICLE_NOT_AVAILABLE_FOR_SALE: "Article non disponible à la vente",
        ARTICLE_NOT_AVAILABLE_ONLINE: "Article non disponible en ligne",
        WEB_ONLINE_START_DATE_BEFORE_TODAY: "L’article n’est pas disponible actuellement",
        WEB_ONLINE_DEADLINE_EXPIRED: "L’article n’est pas disponible actuellement",
        ARTICLE_TYPE_NOT_SIMPLE: "Type d'article non simple",
        ADRESS_1_FORM: "Adresse 1",
        ADRESS_2_FORM: "Adresse 2",
        ADRESS_3_FORM: "Adresse 3",
        CITY_FORM: "Ville",
        POSTAL_CODE_FORM: "Code postal",
        COUNTRY: "Pays",
        VALIDATE: 'Valider',
        CANCEL: 'Non, annuler',
        BILLING_ADDRESS: 'Adresse de facturation',
        DELIVERY_ADDRESS: 'Adresse de livraison',
        MY_ACCOUNT: "Mon compte",
        ECOMMERCE_IS_NOT_CONFIGURED_FOR_THIS_STORE: "E-commerce n'est pas configuré",
        SOMETHING_WENT_WRONG: "Oups, quelque chose s'est mal passé !",
        REFRESH: "Actualiser",
        OPERATION_FAILED: "Opération échouée",
        DECLINATION_PRINCIPLE_PRICE: ({ MaskOnBlur = () => null,
            minDeclinationPrinciplePriceInclTax,
            maxDeclinationPrinciplePriceInclTax, symbol, precision }) => `De ${MaskOnBlur(minDeclinationPrinciplePriceInclTax, symbol, precision)} à ${MaskOnBlur(maxDeclinationPrinciplePriceInclTax, symbol, precision)}`,

        DELETE_LIGNE: "Oui, supprimer la ligne",
        CANCEL_LIGNE: "Annuler",
        CONFIRM_DIALOG_TITLE_BLOCK: "Etes vous sûr de vouloir supprimer la ligne ?",
        CONFIRM_VALIDATION_BUTTON: "Valider",
        WOULD_YOU_REALLY_LIKE_TO_CONFIRM_YOUR_CART: "Voulez-vous vraiment valider votre panier ?",
        VALIDATE_CART_CONFIRM_ORDER_WITH_PICKUP_LIGNE_1: "Confirmez-vous votre commande avec retrait en magasin ?",
        VALIDATE_CART_CONFIRM_ORDER_WITH_PICKUP_LIGNE_2: "En cliquant sur “Valider”, votre commande sera préparée et le règlement sera effectué en magasin.",
        PROCEED_TO_PAYMENT_CONFIRM_ORDER_WITH_PICKUP_LIGNE_1: "Confirmez-vous votre commande avec paiement en ligne ?",
        PROCEED_TO_PAYMENT_CONFIRM_ORDER_WITH_PICKUP_LIGNE_2: "En cliquant sur “Valider”, vous serez redirigé vers un lien de paiement.",
        YOU_HAVE_NO_ITEMS_IN_YOUR_CART: "Vous n'avez aucun article dans votre panier",
        LOGOUT: "Me déconnecter",
        COPY_INTO_THE_DELIVERY_ADDRESS: "Copier dans l'adresse de livraison",
        NO_TEXT_LABEL: "Aucune option",
        PRODUCT_ADDED_SUCCESSFULLY: "Produit ajouté avec succès",
        ERROR_AVAILABLE_STOCK: "Stock Indisponible",
        ERROR_SELECT_VARIANT_VALUE: "Sélectionner une option dans la liste disponible des valeurs de variables",
        HOME: "Accueil",
        YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED: "Votre paiement a été effectué avec succès",  YOUR_CANCEL_PAYMENT_LINK_HAS_BEEN_SUCCESSFULLY_PROCESSED:"Lien de paiement annulé avec succès",
        CONTINUE_SHOPPING: "Poursuivre les Achats",
        TRY_AGAIN: "Réessayer",
        YOUR_PAYMENT_HAS_FAILED: 'Votre paiement a échoué. Veuillez vérifier les informations et réessayer',
        VIEW_ALL: 'Tout voir',
        CATEGORIES: 'Découvrez nos catégories',
        ENTER_YOUR_EMAIL_ADDRESS: 'Entrer votre adresse email',
        VIEW_MORE: 'Voir plus',
        DISCOUNT: (value) => `Remise (${value})`,
        ORDER_SUMMARY: 'Résumé de la commande',
        DELIVERY_FEE: 'Frais de livraison',
        SUBTOTAL: 'Sous-total', 
        OR_CREATE_A_ACCOUNT: "ou créez un compte",
        SAME_BILLING_ADDRESS: "Adresse de facturation identique", 
        POSTAL_ADRESS: 'Adresse postale',
        ADRESS: 'Adresse',
        MY_INFORMATION: 'Mes informations',
        YOU_MIGHT_ALSO_LIKE: 'Vous pourrier aussi aimer',
        YOU_MIGHT_ALSO_LIKE_2: 'Vous aimerez aussi',  
        SIGN_UP_NOW: "S'inscrire maintenant",
        SEARCH_FOR_PRODUCTS: "Rechercher des produits...",

        PRODUCTS: 'Produits',
         EMPTY_THE_CART: "Vider le panier",
        SAVE: 'Enregistrer',
        CONFIRM_DIALOG_EMPTY_THE_BASKET:"Vider le panier ?",
        PREVIOUS: 'Précédent',
        NEXT: 'Suivant',
        SELECT: 'Sélectionner',
        TOTAL_ELEMENTS:(total)=>`${total} produit${total === 1 ? '' : 's'}`,
        SHOWING_PRODUCTS : (page, totalElements) => totalElements ? `Affichage de ${ page.pageNumber * page.pageSize - (page.pageSize - 1) }-${ (page.pageNumber * page.pageSize) > totalElements ? totalElements : (page.pageNumber * page.pageSize) } sur ${totalElements} produits` : `${totalElements} produit${totalElements === 0 ? 's' : ''}`,
       
        GOOD_MORNING: (name) => `Bonjour ${name},`,
        'THE_NEW_ARTICLES_?':(name)=>`Les nouveautés : ${name}`,
        DISCOVER_THE_UNIVERSE :(nameSubUniverses)=>`Découvrez l’univers : ${nameSubUniverses}`,
        ARTICLE_IN_STOCK:'Articles en stock',
        CANCEL_PAYMENT_LINK:"Annuler le lien de paiement",
        EMPTY_PRODUCTS:'Aucun produit disponible',
        ARTICLE_TO_ADD_TO_CART:'Article à ajouter au panier',
        MARK:"Marque",
        VALIDATE_MY_ORDER: "Valider ma commande", 
        CONTINUE_SHOPPING_2:'Continuer mes achats',
        COMMAND:'Commander',
        DELETE:'Supprimer',
        COOKIE_POLICY:'Politique de cookies',
        COOKIE_TEXT:"Nous utilisons uniquement des cookies strictement nécessaires au fonctionnement de notre site. Pour plus de détail, contactez nous !",
        COOKIE_TITLE: "Notre politique de cookies",
        ACCEPT:'Accepter',
        REFUSED:"Refuser",
        CONFIRM_PASSWORD:"Confirmation mot de passe",
        STARTING_FROM:"À partir de ",
        RETURN_CONDITIONS: "Conditions de retours : ",
        DISCOVER_OUR_PRODUCTS: "Découvrir nos produits",
        DISCOVER_OUR_PRODUCTS_AND_ADD_YOUR_FAVORITES:"Découvrez nos produits et ajoutez vos favoris!", 
        YOUR_CART_IS_EMPTY: "Votre panier est vide",
        TITLE_EMPTY_CART: "Votre panier",
        YOUR_ITEM_HAVE_BEEN_SUCCESSFULLY_ADDED_TO_YOUR_CART :(name)=><>{name} <span style={{ fontWeight:400, color:'#737373' }}> ajouté à votre panier </span></> ,
   ENTER_YOUR_INFORMATION_TO_CONTINUE:'Renseignez vos informations pour continuer',
   LOG_IN_TO_VIEW_YOUR_ORDERS:'Connectez-vous pour retrouver vos commandes',
   OR:'OU',
   ALREADY_A_CUSTOMER:"Déjà client ?",
   LOG_IN:'Se connecter',
   CREATE_MY_ACCOUNT:'Créer mon compte',
   WELCOME:(name)=>`Bonjour${name ? ` ${name}, ` : ''}`,
   SECURITY:"Sécurité",
   CHANGE_MY_PASSWORD:'Modifier mon mot de passe',
   ORDER_HISTORY:'Historique des commandes',
   EDIT:'Modifier',
   DELIVERY_ADDRESS_IS_THE_SAME_AS_THE_BILLING_ADDRESS:"L’adresse de livraison est la même que l’adresse de facturation",
   BILLING_ADDRESS_IS_THE_SAME_AS_THE_DELIVERY_ADDRESS:"L’adresse de facturation est la même que l’adresse de livraison",
IN_STORE_PICKUP:'Retrait en magasin',
HOME_DELIVERY:'Livraison à domicile',
ESTIMATED_AT_AROUND_THE:"Estimée vers le ",
NOTE_FOR_SELLER:({rep,theme})=><>Note pour le vendeur {rep ? <span style={{
    color : theme?.text?.secondaryLight,
}}>(modifiée)</span>: ''}</>,
 
    },
    ENGLISH: {
ESTIMATED_AT_AROUND_THE:"Estimated at around the",
HOME_DELIVERY:'Home delivery',
IN_STORE_PICKUP:'In-store pickup',
   DELIVERY_ADDRESS_IS_THE_SAME_AS_THE_BILLING_ADDRESS:"Delivery address is the same as the billing address",
   BILLING_ADDRESS_IS_THE_SAME_AS_THE_DELIVERY_ADDRESS:"Billing address is the same as the delivery address",
        CATEGORIES: 'Categories',
        VIEW_ALL: 'View all',
        DESCRIPTION: "Detailed description",
        FREE_IN_N_HOURS_FROM: (days = 2 ) => `DELIVERY DEADLINE ${days}d`,/** FROM ${MaskOnBlur(price, symbol,precision)} */
        ADD_TO_CART: 'Add to cart',
        REFERENCE: (ref) => `Reference : ${ref}`,
        SIGN_IN: 'Sign in',
        ALREADY_HAVE_AN_ACCOUNT: 'Already have an account ?',
        ALREADY_EXIST_EMAIL: 'This email is already associated with an existing account.',
        CLICK_ON:'Please click on',
        FOR_CONNEXION:'to log in.',
        PASSWORD_FORGOTTEN:'If you have forgotten your password, use the option',
        PASSWORD_RESET:'to reset it.',
        CREATE: 'Create',
        PASSWORD: 'Password', 
        EMAIL: 'Email',
        LAST_NAME: 'Last name',
        FIRST_NAME: 'First name',
        FIELD_REQUIRED: "This field is required",
        INVALID_EMAIL_ADDRESS: 'Invalid email address',
        INVALID_PHONE_NUMBER: 'Invalid phone number',
        CUSTOMER_LOGIN: 'Log in',
        NEW_CUSTOMER_SIGN_UP: 'New Customer? Sign Up!',
        ACCOUNT: 'Account', 
        LANGUAGE: 'language',
        ENGLISH: 'English',
        FRENCH: 'French',
        FORGOT_PASSWORD: "Forgot password ?",
        TITLE_FORGOT_PASSWORD: "Forgot password", 
        ENTER_CODE: "Enter the code",
        CONFIRMATION: "Confirmation",
        CHANGE: "Change",
        PASSWORD_MUST_BE_AT_LEAST_6_CHARACTERS: "Password must be at least 6 characters",
        PASSWORDS_ARE_NOT_THE_SAME: "Passwords are not the same",
        PLEASE_CONFIRM_YOUR_NEW_PASSWORD: 'Please confirm your new password',
        PASSWORD_REQUIREMENTS: "Your password must contain at least: 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character",
        NEW_PASSWORD: "New password",
        IS_COMPANY: 'Company',
        COMPANY_NAME: "Company name",
        CELLPHONE: "Phone",
        CREATE_AN_ACCOUNT: "Create an account",
        OPERATION_SUCCESS: "Operation completed successfully",
        OPERATION_CHANGE_PASSWORD_SUCCESS: 'Your password has been successfully changed !',
        PRODUCTS_LEFT: (stoke = 0, withNegativeStock = false, articleId) => withNegativeStock && articleId ? 'In stock' : (stoke > 0 && articleId) ? `There are ${stoke} products left` : 'Sold Out',
        PRODUCTS_LEFT_SHOPY: (stoke = 0, withNegativeStock = false, articleId) => (withNegativeStock ||stoke > 0) && articleId ? 'In stock' :'Sold Out',
        SHOP_NOW: "Shop Now",
        SEARCH: "Search",
        PRODUCT: 'Product',
        TOTAL: 'Total',
        QTY: 'Qty',
        REMOVE: 'Remove',
        CHECK_OUT: "Check Out",
        ARTICLE_NOT_FOUND: "Article not found",
        ARTICLE_NOT_ACTIF: "Article not active",
        ARTICLE_NOT_AVAILABLE_FOR_SALE: "Article not available for sale",
        ARTICLE_NOT_AVAILABLE_ONLINE: "Article not available online",
        WEB_ONLINE_START_DATE_BEFORE_TODAY: "Article is not currently available",
        WEB_ONLINE_DEADLINE_EXPIRED: "Article is not currtotalently available",
        ARTICLE_TYPE_NOT_SIMPLE: "Article type not simple",
        ADRESS_1_FORM: "Adress 1",
        ADRESS_2_FORM: "Adress 2",
        ADRESS_3_FORM: "Adress 3",
        POSTAL_CODE_FORM: "Postal Code",
        CITY_FORM: "City",
        COUNTRY: "Country",
        VALIDATE: 'Validate',
        CANCEL: 'No, cancel',
        BILLING_ADDRESS: 'Billing address',
        DELIVERY_ADDRESS: 'Delivery address',
        MY_ACCOUNT: "My account", 
        ECOMMERCE_IS_NOT_CONFIGURED_FOR_THIS_STORE: "E-commerce is not configured",
        SOMETHING_WENT_WRONG: "Oops, something went wrong!",
        REFRESH: "Refresh",
        OPERATION_FAILED: "Operation failed",
        DECLINATION_PRINCIPLE_PRICE: ({ MaskOnBlur = () => null,
            minDeclinationPrinciplePriceInclTax,
            maxDeclinationPrinciplePriceInclTax, symbol, precision }) => `From ${MaskOnBlur(minDeclinationPrinciplePriceInclTax, symbol, precision)} to ${MaskOnBlur(maxDeclinationPrinciplePriceInclTax, symbol, precision)}`,
        DELETE_LIGNE: "Yes, delete the row",
        CANCEL_LIGNE: "Cancel",
        CONFIRM_DIALOG_TITLE_BLOCK: "Are you sure you want to delete the row ?",
        CONFIRM_VALIDATION_BUTTON: "Validate",
        WOULD_YOU_REALLY_LIKE_TO_CONFIRM_YOUR_CART: "Would you really like to confirm your cart ?",
        VALIDATE_CART_CONFIRM_ORDER_WITH_PICKUP_LIGNE_1: "Do you confirm your order with in-store pickup ?",
        VALIDATE_CART_CONFIRM_ORDER_WITH_PICKUP_LIGNE_2: "By clicking on 'Validate', your order will be prepared and payment will be made in-store.",
        PROCEED_TO_PAYMENT_CONFIRM_ORDER_WITH_PICKUP_LIGNE_1: "Do you confirm your order with online payment ?",
        PROCEED_TO_PAYMENT_CONFIRM_ORDER_WITH_PICKUP_LIGNE_2: "By clicking on Validate, you will be redirected to a payment link.",
        YOU_HAVE_NO_ITEMS_IN_YOUR_CART: "You have no items in your cart",
        LOGOUT: "Logout",
        COPY_INTO_THE_DELIVERY_ADDRESS: "Copy into the delivery address",
        NO_TEXT_LABEL: "No options",
        PRODUCT_ADDED_SUCCESSFULLY: "Product added successfully",
        ERROR_AVAILABLE_STOCK: "Stock Unavailable",
        ERROR_SELECT_VARIANT_VALUE: "Select an option from the available list of variable values",
        HOME: "Home",
        CART: "Cart",
        YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED: "Your payment has been successfully processed",
        YOUR_CANCEL_PAYMENT_LINK_HAS_BEEN_SUCCESSFULLY_PROCESSED:"Payment link successfully canceled",
        CONTINUE_SHOPPING: "Continue Shopping",
        TRY_AGAIN: "Try again",
        YOUR_PAYMENT_HAS_FAILED: 'Your payment has failed. Please verify the information and try again',
        ENTER_YOUR_EMAIL_ADDRESS: 'Enter your email address',
        VIEW_MORE: 'View more',
        DISCOUNT: (value) => `Discount (${value})`,
        ORDER_SUMMARY: 'Order Summary',
        DELIVERY_FEE: 'Delivery fee',
        SUBTOTAL: 'Subtotal',
        OR_CREATE_A_ACCOUNT: "or create an account",
        "IS_COMPANY_?": 'Company client?',
        SAME_BILLING_ADDRESS: "Same billing address",
        POSTAL_ADRESS: 'Postal address', 
        ADRESS: 'Address',
        MY_INFORMATION: 'My information',
        SAVE:'Save',
        YOU_MIGHT_ALSO_LIKE: 'You might also like',
        YOU_MIGHT_ALSO_LIKE_2: 'You might also like',
        SIGN_UP_NOW: 'Sign up now',
        SEARCH_FOR_PRODUCTS: "Search for products...",
        MY_CART: "My cart",
        MY_CART_UIX2:(nb)=>`My cart (${nb} article${nb !== 1 ? 's' : ''})`,
        GOOD_MORNING: (name) => `Good morning ${name},`,
        PRODUCTS: 'Products',
        TOTAL_ELEMENTS:(total)=>`${total} product${total === 1 ? '' : 's'}`,
        SHOWING_PRODUCTS:(page,totalElements)=>totalElements ? `Showing ${ page.pageNumber * page.pageSize - (page.pageSize -1) }-${ (page.pageNumber * page.pageSize) > totalElements ? totalElements : (page.pageNumber * page.pageSize) } of ${totalElements } products`:`${totalElements} product${totalElements === 0 ? 's' :''}`,
    
        VALIDATE_CART: "Click and Collect",
        PROCEED_TO_PAYMENT: "Online payment",
        EMPTY_THE_CART: "Empty the cart",
        CONFIRM_DIALOG_EMPTY_THE_BASKET:"Empty the cart ?",
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        SELECT: 'Choose',
        'THE_NEW_ARTICLES_?':(name)=>`The new articles: ${name}`,

        DISCOVER_THE_UNIVERSE :(nameSubUniverses)=>`Discover the universe : ${nameSubUniverses}`,
        ARTICLE_IN_STOCK:'Articles in stock',
        CANCEL_PAYMENT_LINK:"Cancel payment link",
   
        EMPTY_PRODUCTS:'No products available',
        ARTICLE_TO_ADD_TO_CART:'Article to add to cart',
        MARK:"Mark",
        VALIDATE_MY_ORDER: "Validate my order", 
        CONTINUE_SHOPPING_2:'Continue shopping',
        DELETE:'Delete',
        COOKIE_POLICY:'Cookie policy',
        COOKIE_TEXT:'We only use strictly necessary cookies for the operation of our site. For more details, contact us!',
        ACCEPT:'Accept',
        COOKIE_TITLE: "Our cookies policy",
        REFUSED:"Refused",
        CONFIRM_PASSWORD:"Password confirmation",
        STARTING_FROM:"Starting from ",
        RETURN_CONDITIONS: "return conditions : ",
        DISCOVER_OUR_PRODUCTS: "Discover our products",
        DISCOVER_OUR_PRODUCTS_AND_ADD_YOUR_FAVORITES:"Discover our products and add your favorites!", 
        YOUR_CART_IS_EMPTY: "Your cart is empty",
        TITLE_EMPTY_CART: "Your Cart",
        YOUR_ITEM_HAVE_BEEN_SUCCESSFULLY_ADDED_TO_YOUR_CART :(name)=><>{name} <span style={{
            fontWeight:400,
            color:'#737373'
        }}> added to your cart </span></> ,
        COMMAND:'Place an order',

           ENTER_YOUR_INFORMATION_TO_CONTINUE:'Enter your information to continue',
   LOG_IN_TO_VIEW_YOUR_ORDERS:'Log in to view your orders',
   OR:'OR',
   ALREADY_A_CUSTOMER:"Already a customer ?",
   LOG_IN:'Log in',
   CREATE_MY_ACCOUNT:'Create my account',
   WELCOME:(name)=>`Good morning${name? ` ${name}, ` : ''}`,
   SECURITY:"Security",
   CHANGE_MY_PASSWORD:'Change my password',
      ORDER_HISTORY:'Order history',
   EDIT:'Edit',
NOTE_FOR_SELLER:({rep,theme})=><>Note for seller {rep ?<span style={{
    color : theme?.text?.secondaryLight,
}}>(edit)</span>: ''}</>,
    }
}

export default TRANSLATION;